import { HomeAnnouncementTable, HomeGroupLayout } from 'components';
import React from 'react';

/**
 * 公告頁面
 */

export const HomeAnnouncementPage = () => {
  return (
    <HomeGroupLayout>
      <HomeAnnouncementTable />
    </HomeGroupLayout>
  );
};


